import React, { useMemo } from "react";
import { buildSideBySide, diffStats } from "@/lib/htmlDiff";
import { TEMPLATES } from "@/constants/testIds";

const CELL_BG = {
  same: ["", ""],
  changed: ["bg-red-50", "bg-emerald-50"],
  removed: ["bg-red-50", "bg-slate-50"],
  added: ["bg-slate-50", "bg-emerald-50"],
};
const HL = ["bg-red-200 text-red-900 rounded-sm", "bg-emerald-200 text-emerald-900 rounded-sm"];

function Cell({ side, row, idx }) {
  const cell = row[side];
  const bg = CELL_BG[row.type][idx];
  return (
    <>
      <td className={`w-10 px-2 text-right select-none text-slate-400 border-r border-slate-100 ${bg}`}>
        {cell?.n ?? ""}
      </td>
      <td className={`px-2 whitespace-pre-wrap break-all ${bg}`}>
        {cell?.segs.map((s, i) => (
          <span key={`${i}-${s.text}`} className={s.hl ? HL[idx] : undefined}>{s.text}</span>
        ))}
      </td>
    </>
  );
}

export function HtmlDiffView({ oldHtml, newHtml }) {
  const rows = useMemo(() => buildSideBySide(oldHtml, newHtml), [oldHtml, newHtml]);
  const stats = diffStats(rows);
  return (
    <div className="space-y-2">
      <div className="text-[11px] text-slate-600" data-testid={TEMPLATES.compareDiffStats}>
        <span className="text-emerald-700 font-semibold">+{stats.added}</span> líneas ·{" "}
        <span className="text-red-700 font-semibold">−{stats.removed}</span> líneas
      </div>
      <div className="border border-slate-200 rounded-md overflow-auto max-h-[52vh]">
        <table className="w-full table-fixed font-mono text-[11px] leading-5" data-testid={TEMPLATES.compareDiffTable}>
          <colgroup><col className="w-10" /><col /><col className="w-10" /><col /></colgroup>
          <tbody>
            {rows.map((row) => (
              <tr key={`${row.left?.n ?? "x"}-${row.right?.n ?? "x"}`} data-diff-type={row.type}>
                <Cell side="left" row={row} idx={0} />
                <Cell side="right" row={row} idx={1} />
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
